import React from 'react'
import "./disclaimer.css"
import { Link, useNavigate } from 'react-router-dom'
import WhatsAppChatBtn from '../whatsAppChatBtn/WhatsAppChatBtn'

function Disclaimer() {
  const navigate = useNavigate()
  return (
    <article class="disclmer_card">
  <section class="disclmer_card__hero">
    <header class="disclmer_card__hero-header">
      <span>Disclaimer</span>
      <div class="disclmer_card__icon">
        <svg
          height="20"
          width="20"
          stroke="currentColor"
          stroke-width="1.5"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z"
            stroke-linejoin="round"
            stroke-linecap="round"
          ></path>
        </svg>
      </div>
    </header>

    <div className='tnc-wp'>
                    <h3 className='tnc-header'>Charges for Curation <span style={{fontSize: "0.6rem"}}><Link to={"/termandcond"}>( Already mention on T&C )</Link></span></h3>
                    <ul className='list-wp'>

                        <li>
                            <div>
                                <p className='rp-desc'>The fees charged on our platform are for the service of curating, organizing, and presenting publicly available resources in a structured manner for user convenience.</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <p className='rp-desc'>We do not charge for the content of third-party resources or websites, which remain freely accessible through their original platforms.</p>
                            </div>
                        </li>
    </ul>

                </div>

                <div className='tnc-wp'>
                    <h3 className='tnc-header'>Credits</h3>
                    <ul className='list-wp'>

                        <li>
                            <div>
                                <p className='rp-desc'>We have sheared the youtube links of YouTube creator <Link to={"https://www.youtube.com/@NeetCode"}><b>NeetCode</b></Link>
                                </p>
                            </div>
                        </li>
                        <li>
                            <div>
                            <p className='rp-desc'>We have sheared problem links of website <Link to={"https://leetcode.com/"} ><b>LeetCode</b></Link>
                                </p>
                            </div>
                        </li>
    </ul>

                </div>


  </section>

  <footer class="disclmer_card__footer">
    <div class="disclmer_card__job-summary">
      <div class="qry-icon">
        <img src='../../../img/infoIcon.svg' alt='logo' />
      </div>
      <div class="disclmer_card__job">
        <p class="disclmer_card__job-title">
          Any Query?<br />
          Please Message us
        </p>
      </div>
    </div>

    <WhatsAppChatBtn />  
  </footer>
</article>
  )
}

export default Disclaimer